import React from 'react';
// import './AP css.css'
import Secondsection from './Component/Secondsection'
// import Thirdsection from './Component/Thirdsection'
import Fouthsection from './Component/Fouthsection'
import Sixthsection from './Component/Sixthsection'
import Footer from './Component/footer'
import { Element } from 'react-scroll'

const About = () => {
    
    return (
        <div >
        
         
        
         <Element  id='about' name=''> 
      <Secondsection />
      </Element>

   { /* <Element  id='Service' name='Service'> 
      <Thirdsection />
      </Element>
 */ } 
      <Element  id='fouth' name='Service'> 
      <Fouthsection  />
      </Element>

      <Element  id='Six' name='Service'> 
      <Sixthsection />
      </Element>
      
      <Element  id='contact' name='footer'> 
      <Footer />
      </Element>

        </div>
    )
}

export default About